import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    getIndexedContentSearchResults as GqlIndexedContentSearchResults,
    getIndexedContentSearchResultsVariables as GqlIndexedContentSearchResultsVariables,
} from "./__graphql-types__/getIndexedContentSearchResults.ts";

export const INDEXED_CONTENT_SEARCH_QUERY: GqlOperation<
    GqlIndexedContentSearchResults,
    GqlIndexedContentSearchResultsVariables
> = gqlOp(gql`
    query getIndexedContentSearchResults(
        $query: String!
        $allowedTopicAncestors: [String]
        $contentKinds: [String]
        $pageNum: Int
        $numResults: Int
    ) {
        searchPage(
            query: $query
            allowedTopicAncestors: $allowedTopicAncestors
            contentKinds: $contentKinds
            pageNum: $pageNum
            numResults: $numResults
        ) {
            metadata {
                currentPage
                numPages
                resultCount
            }
            pageInfo {
                nextCursor
            }
            results {
                contentId
                kind
                curationNode {
                    id
                    contentKind
                    slug
                    iconPath
                    translatedTitle
                    translatedDescription
                    relativeUrl
                    topicPaths {
                        path {
                            id
                            kind
                            slug
                            content {
                                ... on Topic {
                                    id
                                    curriculumKey
                                    iconPath
                                    translatedTitle
                                }
                            }
                        }
                    }
                }
                learnableContent {
                    id
                    contentKind
                    slug
                    translatedTitle
                    translatedDescription
                    defaultUrlPath
                    topicPaths {
                        path {
                            id
                            kind
                            slug
                            content {
                                ... on Topic {
                                    id
                                    curriculumKey
                                    iconPath
                                    translatedTitle
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`);
